import log from 'loglevel';
import * as React from 'react';

export interface ClickAwayProps {
    onClickAway: () => void;
    rootId?: string;
}

export function useClickAway(ref: any, handler: () => void, rootId?: string) {
    React.useEffect(() => {
        function handleClickAway(e: any) {
            //log.debug('clickAway handler', rootId);
            if (ref.current && !ref.current.contains(e.target)) {
                handler && handler();
            }
        }

        const wrappedElement = rootId ? document.getElementById(rootId) : document;

        if (wrappedElement) {
            wrappedElement.addEventListener('mousedown', handleClickAway);
            return () => {
                wrappedElement.removeEventListener('mousedown', handleClickAway);
            };
        } else {
            log.warn('clickAway: could not find element to wrap', rootId);
        }
    }, [ref, handler]);
}

export const ClickAway: React.FC<React.PropsWithChildren<ClickAwayProps>> = ({
    children,
    onClickAway,
    rootId,
}: React.PropsWithChildren<ClickAwayProps>) => {
    const wrapperRef = React.useRef(null);
    useClickAway(wrapperRef, onClickAway, rootId);

    return <div ref={wrapperRef}>{children}</div>;
};
